module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAYUlEQVQoU2NkwAJ4zdrU/v39w/71bN1ldGlGrBqMW2wYGP+tYWRg8vt0puYUshqsGkAK+EybPf7//78AXRNODbg04dWATRNBDcia/v1ncKW+BnTPU8/TJAUrL6kRhy9pAAArrFfn2xK/3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right.png
// module id = PrUr
// module chunks = 1